import { render } from "./IconBin.vue?vue&type=template&id=4b1153b0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1153b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1153b0', __exports__)) {
    api.reload('4b1153b0', __exports__)
  }
  
  module.hot.accept("./IconBin.vue?vue&type=template&id=4b1153b0", () => {
    api.rerender('4b1153b0', render)
  })

}


export default __exports__